<template>
  <div class="home-page">
    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab"
      img-width="1024" img-height="480" @sliding-start="onSlideStart" @sliding-end="onSlideEnd" next-text=""
      prev-text="">
      <b-carousel-slide :img-src="homePage1" @click.native="goToPage('/White-Wood')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">白+木
            <br>
            White and Wood
          </p>
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="homePage2" @click.native="goToPage('/White-Wood')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">白+木
            <br>
            White and Wood
          </p>
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="homePage3" @click.native="goToPage('/Romance-In-The-House')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">漫乐
            <br>
            Romance in the house
          </p>
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="homePage4" @click.native="goToPage('/Romance-In-The-House')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">漫乐
            <br>
            Romance in the house
          </p>
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="homePage5" @click.native="goToPage('/Perfect-In-Black')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">墨
            <br>
            Perfect in black
          </p>
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="homePage6" @click.native="goToPage('/Perfect-In-Black')">
        <div class="carousel-title ">
          <p class="noto noto-title-lg-400 text-left m-0">墨
            <br>
            Perfect in black
          </p>
        </div>
      </b-carousel-slide>
    </b-carousel>
    <div class="works ">
      <div class="amalfi-coast-title amalfi-coast">
        <img src="../assets/img/crafted-from-passion.png" class="cafted-text-img" alt="">
      </div>
      <div class="container">
        <div class="row">
          <router-link class="col-md-6 col-sm-12 pb-56" to="White-Wood">
            <img src="../assets/img/homepage/project-01-white+wood.jpg"
              alt="白 + 木 | White + Wood. Semi D, Eco Spring | Johor">
            <p class="playfair playfair-title-sm-400 black">白 + 木 | White + Wood</p>
            <span class="inter inter-body-md-400 gray-400">USJ 5 | Subang Jaya</span>
          </router-link>
          <router-link class="col-md-6 col-sm-12 pb-56" to="Romance-In-The-House">
            <img src="../assets/img/homepage/project-02-romance-in-the-house.jpg"
              alt="漫乐 | Romance in the house. Eco Spring | Johor">
            <p class="playfair playfair-title-sm-400 black">漫乐 | Romance in the house</p>
            <span class="inter inter-body-md-400 gray-400">Eco Spring | Johor</span>
          </router-link>
          <router-link class="col-md-6 col-sm-12 pb-56" to="Comfort-Zone">
            <img src="../assets/img/homepage/project-03-comfort.jpg" alt="舒窝 | Comfort Zone. Sunway Mont | Mont Kiara">
            <p class="playfair playfair-title-sm-400 black">舒窝 | Comfort Zone</p>
            <span class="inter inter-body-md-400 gray-400">Sunway Mont | Mont Kiara</span>
          </router-link>
          <router-link class="col-md-6 col-sm-12 pb-56" to="Grey-Song">
            <img src="../assets/img/homepage/project-04-grey-song.jpg" alt="岩灰 | Grey Song. Kiaraville | Mont Kiara">
            <p class="playfair playfair-title-sm-400 black">岩灰 | Grey Song</p>
            <span class="inter inter-body-md-400 gray-400">Kiaraville | Mont Kiara</span>
          </router-link>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-button variant="dark" class="inter inter-body-lg-600" to="works" tag="router-link">More Works <img
                class="p-0" src="../assets/img/icon/arrow_forward.svg" alt=""></b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="works-details-row primary-bg">
      <div class="row flex-center">
        <div class="col-12 col-xl-7  ">
          <router-link :to="{ path: '/works', query: { tab: 'bungalow' } }">
            <div class="works-details-img">
              <img src="../assets/img/homepage/type-bungalow.jpg" alt="type-bungalow">
              <div class="works-details-title">
                <p class="playfair title-1">Bungalow</p>
                <p class="noto title-2">独立式</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-xl-7  ">
          <router-link :to="{ path: '/works', query: { tab: 'semiD' } }">
            <div class="works-details-img">
              <img src="../assets/img/homepage/type-semi-d.jpg" alt="type-semi-d">
              <div class="works-details-title">
                <p class="playfair title-1">Semi-Detached</p>
                <p class="noto title-2">半独立</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-xl-7  ">
          <router-link :to="{ path: '/works', query: { tab: 'linkHouseCondo' } }">
            <div class="works-details-img">
              <img src="../assets/img/homepage/type-link-house-condo.jpg" alt="type-link-house-condo">
              <div class="works-details-title">
                <p class="playfair title-1">Link house / Condominium</p>
                <p class="noto title-2">排屋/公寓</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-xl-7  ">
          <router-link :to="{ path: '/works', query: { tab: 'designConcept' } }">
            <div class="works-details-img">
              <img src="../assets/img/homepage/type-concept.jpg" alt="type-concept">
              <div class="works-details-title">
                <p class="playfair title-1">Concept</p>
                <p class="noto title-2">效果图</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="founder-info-row gray-100">
      <div class="row">
        <div class="col-md-12 p-0">
          <div class="founder-info-img">
            <img src="../assets/img/homepage/founder-sara.jpg" alt="Founder Sara">
          </div>
          <div class="founder-info">
            <p class="noto noto-title-sm-400">
              <img class="colon-top" src="../assets/img/homepage/colon-top.png" alt="">
              生活水准与品质的提升,源自于不断地创新和提升设计的自身价值,<br>并且坚持.
            </p>
            <p class="playfair playfair-title-sm-400 italic">
              quality of life is enhanced through persistent innovation, and via targeted efforts to increase a design’s
              intrinsic value.
              <img class="colon-bottom" src="../assets/img/homepage/colon-bottom.png" alt="">
            </p>
            <img class="width-100" src="../assets/img/homepage/founder-sara-sign.png" alt="Founder Sara">
            <div class="width-100 flex-wrap text-left inter ">
              <span class="inter-body-md-600">
                SARA LIM
              </span>
              <span class=" inter-body-sm-400">
                FOUNDER OF NINE PLUS INTERIOR DESIGN (M) SDN BHD
              </span>
              <span class=" inter-body-sm-400">
                MANAGING DIRECTOR
              </span>
              <span class=" inter-body-sm-400">
                15 YEARS EXPERIENCES
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="founder-info-row mb-112 gray-100">
      <div class="row">
        <div class="col-md-12 p-0">
          <div class="founder-info-img">
            <img src="../assets/img/homepage/founder-christine.jpg" alt="Founder Christine">
          </div>
          <div class="founder-info">
            <p class="noto noto-title-sm-400">
              <img class="colon-top" src="../assets/img/homepage/colon-top.png" alt="">
              设计就是改善和改变是我们的初衷,真正理解和发掘业主的需要,<br>是我们坚持的理念.
            </p>
            <p class="playfair playfair-title-sm-400 italic">
              enhance and innovate is part of our core values. Fully understanding and discovering the client’s needs
              will always be our key design principle.
              <img class="colon-bottom" src="../assets/img/homepage/colon-bottom.png" alt="">
            </p>
            <img class="width-100" src="../assets/img/homepage/founder-chrustine-sign.png" alt="Founder Christine">
            <div class="width-100 flex-wrap text-left inter ">
              <span class="inter-body-md-600">
                CHRISTINE LEE
              </span>
              <span class=" inter-body-sm-400">
                FOUNDER OF NINE PLUS INTERIOR DESIGN (M) SDN BHD
              </span>
              <span class=" inter-body-sm-400">
                CREATIVE DIRECTOR
              </span>
              <span class=" inter-body-sm-400">
                15 YEARS EXPERIENCES
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="awards">
      <div class="amalfi-coast-title amalfi-coast">
        Awards
      </div>
      <div class="awards-img">
        <img src="../assets/img/homepage/awards-01.png" alt="">
        <img src="../assets/img/homepage/awards-02.svg" alt="">
      </div>
    </div>
    <div class="pb-112">
      <div class="amalfi-coast-title amalfi-coast">
        Reviews
      </div>
      <b-carousel id="review-carousel" :interval="4000" indicators controls background="transparent">
        <b-carousel-slide v-for="(group, index) in chunkedReviews" :key="index">
          <template #img>
            <div class="row row-cols-1 row-cols-lg-3 row-cols-sm-2 g-4 px-5">
              <div v-for="(review, i) in group" :key="i" class="col">
                <div class="card h-100 border-0  custom-card">
                  <div class="d-flex pb-24">
                    <img :src="review.image" class="rounded-circle profile-sm "  />
                    <div class="small-text text-left pl-16">
                      <div class="fw-bold name-truncate">{{ review.name }}</div>
                       <img class="star-img" v-for="star in 5" :key="star" src="../assets/img/homepage/dot-active.png" alt=""> 
                    </div>
                  </div>
                  <p class="inter inter-body-md-400 text-left mb-24 gray-400 review-body">"{{ review.text }}"</p>
                  <div class="accent-bar primary-bg"></div>
                </div>
              </div>
            </div>
          </template>
        </b-carousel-slide>

        <template #indicators="{ slideTo, activeIndex }">
          <div class="d-flex justify-content-center gap-2 mt-4 custom-dots">
            <span v-for="(group, idx) in chunkedReviews" :key="idx" class="dot" :class="{ active: idx === activeIndex }"
              @click="slideTo(idx)"></span>
          </div>
        </template>
      </b-carousel>
      <div class="text-center mt-4">
        <a href="https://www.facebook.com/9plusinterior/reviews/?id=100064572827118&sk=reviews" class="btn btn-dark fw-bold fb-btn">  View Review on Facebook  <img src="../assets/img/homepage/fb-icon.svg" alt=""></a>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeComponent',
  data() {
    return {
      slide: 0, // slide variable used for v-model binding
      sliding: null,
      homePage1: require('@/assets/img/homepage/hero-banner-01-white+wood.jpg'),
      homePage2: require('@/assets/img/homepage/hero-banner-02-white+wood.jpg'),
      homePage3: require('@/assets/img/homepage/hero-banner-03-romance-in-the-house.jpg'),
      homePage4: require('@/assets/img/homepage/hero-banner-04-romance-in-the-house.jpg'),
      homePage5: require('@/assets/img/homepage/hero-banner-05-perfect-in-black.jpg'),
      homePage6: require('@/assets/img/homepage/hero-banner-06-perfect-in-black.jpg'),

      allReviews: [
        {
          name: 'Foo David',
          image: require('../assets/img/homepage/review-img1.jpg'),
          text: '我工作缠身，很怕麻烦，尤其像新家装修，繁琐事太多，完全分身不暇，庆幸得人，全程由两名美女设计师 Sara Lim、Chew Yen 及她的伙伴负责，从3D图到施工、颜色、灯光、买家具，都呈现了专业应有的责任，与我夫妇沟通也到位，出来的成果我夫妇两都很满意。我很宅，下班后喜欢呆在家，享受家的温馨，很谢谢她们，为我打造了这样的居住环境。'
        },
        {
          name: 'Charlotte Yuen',
          image: require('../assets/img/homepage/review-img2.jpg'),
          text: '喜欢他们的专业的服务和态度，按照客人的要求设计出独一无二的款式加上融合了设计师Christine 的风格更加不用说了……家里装修了过后，都不想出去了，还是待在家里好，舒服，爱死你们了'
        },
        {
          name: 'Benjamin Teoh',
          image: require('../assets/img/homepage/review-img3.jpg'),
          text: 'Highly recommended for those who are looking to renovate their newly homes. Keep up the good works!'
        }, 
        {
          name: 'Karen Lee',
          image: require('../assets/img/homepage/review-img4.jpg'),
          text: "Thanks for all the help for me and my husband newly wed home. It's beautiful and everyone is very happy. I absolutely loved working with Christine and her team. They made the entire renovation an amazing experience. I would definitely recommend them to anyone. They are professional yet equally personable."
        }, 
        {
          name: 'Caelyn Miao',
          image: require('../assets/img/homepage/review-img5.jpg'),
          text: '我和9+interior 的创办人sara 是从小就认识的好朋友。Sara 是一个我非常钦佩的一个女生。她对室内设计有着独特的触觉与想法，对于她的作品我总是会看了又看。她的设计 - 简单 - 大方 - 温馨 - 舒适 - 凡是你想要梦想家的想法，都能在她的设计里面感受得到。她耐心的了解你的需求，配合你的风格与气质，加上她专业又敏锐的设计想法， 设计作品绝对让你满意。我记得曾经和她一起旅行，一趟4个小时的飞机，她阅读了两本书本。我必须说，她对自己有绝对的要求，一直不断的提升自己，让自己不断的变得更加的出色！ 这样的一个人，天资加上个性，她的作品绝对值得你停一停，看一看， 感受感受一下。 9+ interior 加油！'
        }, 
        {
          name: 'Derrick Wong',
          image: require('../assets/img/homepage/review-img6.jpg'),
          text: 'I have been cooperative for more than 2 years with this company. Sara & Christine are very responsible in works, reliable, kind and sincere in personality which so I highly recommend you to try their service. Their creativity in design of interior works are worth to explore, worth money value too. Glad to works with you all! Thank you!'
        }, 
        {
          name: 'Glen Kit',
          image: require('../assets/img/homepage/review-img7.jpg'),
          text: 'Happy with the professional team  work and great service.  And also the professional opinion and idea'
        }, 
        {
          name: 'Alex Chan',
          image: require('../assets/img/homepage/review-img8.jpg'),
          text: '设计很好，很有现代风格，行走在流行时尚的前沿。'
        }, 
        {
          name: 'Vincent Wong',
          image: require('../assets/img/homepage/review-img9.jpg'),
          text: '专业的意见与服务让身为顾客的我感到很放心设计有独特的风格很满意推荐给需要的你们'
        }, 
        {
          name: 'Fong YF',
          image: require('../assets/img/homepage/review-img10.jpg'),
          text: 'Prompt respond. Friendly and easy to work with. Always think ahead of customer need. Recommended'
        }, 
        {
          name: 'Eunice Goh',
          image: require('../assets/img/homepage/review-img11.jpg'),
          text: '幾年前就找了他們幫我設計房子，很年輕，漂亮很有活力的設計師，設計出來的成果讓我很滿意，簡約，舒適，顏色也搭到好漂亮，重點是老闆娘態度很好，負責人，有擔當，健談，一句總結，他會幫你打造出你最喜歡的房子。讚'
        }, 
        {
          name: 'Yvonne Ng',
          image: require('../assets/img/homepage/review-img12.jpg'),
          text: 'Professional and great services provided. They provided design that suits your need. Friendly and passion working attitude. Kudossss'
        }, 
        {
          name: 'Carmen Ow',
          image: require('../assets/img/homepage/review-img13.jpg'),
          text: '谢谢你们的专业 给与我们意见 重点有责任心在各方面设计和细节都很好 打造了 简约优美又舒适的环境 因此相信 所以放心把屋子交给你们一班团队'
        }, 
        {
          name: 'Jocelyn Khor',
          image: require('../assets/img/homepage/review-img14.jpg'),
          text: 'Christine and Sara paid great attention to every single detail. Kudos to the team! Very nice and job well done!'
        }, 
        {
          name: 'Charlene Lim Cheow Yun',
          image: require('../assets/img/homepage/review-img15.jpg'),
          text: '非常有责任感，很喜欢他们的设计，会给出合适的建议认真的态度值得学习 赞赞赞'
        }, 
      ]
    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'Default Title',
      meta: [
        {
          name: 'description',
          content: this.$route.meta.description || 'Default description',
        },
        {
          name: 'keywords',
          content: this.$route.meta.keywords || 'Default keywords',
        }
      ]
    };
  },
  computed: {
    chunkedReviews() {
      const chunks = [];
      for (let i = 0; i < this.allReviews.length; i += 6) {
        chunks.push(this.allReviews.slice(i, i + 6));
      }
      return chunks;
    }
  },
  methods: {
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    goToPage(url) {
      this.$router.push(url);
    },
  }
}
</script>

<style>
.home-page .carousel-inner img {
  width: 100% !important;
  height: 100vh !important;
  object-fit: cover;
}

#review-carousel .carousel-inner img {
  width: 50px !important;
  height: 50px !important;
}

.home-page .carousel-control-next,
.home-page .carousel-control-prev {
  bottom: 16%;
  top: unset;
}

.home-page .carousel-control-next {
  right: 3%;
}

.home-page .carousel-control-prev,
.home-page .carousel-control-next .sr-only,
.home-page .carousel-control-prev .sr-only {
  display: none;
}

.home-page .carousel-caption {
  width: 18%;
  right: 9%;
  left: unset;
  bottom: 13%;
  padding: 0;
}

.carousel-control-next-icon {
  background-image: url('../assets/img/icon/arrow_forward.svg') !important;
  background-size: contain;
  background-repeat: no-repeat;
  width: 30px;
  height: 30px;

}
#review-carousel .carousel-control-next-icon{
  display: none;
}
.carousel-control-next,
.carousel-control-prev {
  opacity: 1 !important;
}

.home-page .carousel-indicators li {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #8E8E93;
  opacity: 0.6;
  margin-right: 24px;
  list-style: none;
}

.home-page .carousel-indicators .active {
  background-color: #fff;
  opacity: 1;
}
.home-page #review-carousel .carousel-indicators li {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #8E8E93;
  opacity: 0.6;
  margin-right: 24px;
  list-style: none;
  position: unset; 
}
.home-page #review-carousel ol{
  position: unset;
  padding: 56px 0 40px;
}
.home-page #review-carousel .carousel-indicators .active {
  background-color: #000;
  opacity: 1;
}
.works {
  padding-bottom: 112px;
}

.works p {
  margin-bottom: 0;
  padding-top: 24px;
}

.pb-56 {
  padding-bottom: 56px;
}

.works img {
  width: 100%;
}

.works .btn {
  width: 170px;
  height: 52px;
  padding: 15px;
  border-radius: unset;
}

.works .btn img {
  width: 12px;
  height: 12px;
  margin-left: 5px;
}

.works button {
  padding: 16px 24px;
  border-radius: 0;
}

.works button img {
  width: 20px;
  margin-left: 8px;
}

.works-details-row {
  padding: 112px 120px;
}

.works-details-row .title-1 {
  font-size: 30px;
  letter-spacing: 0.5em;
  margin-bottom: 0
}

.works-details-row .title-2 {
  font-size: 16px;
  letter-spacing: 3em;
  padding-left: 70px;
  margin-bottom: 0;
}

.works-details-img {
  position: relative;
  margin-bottom: 56px;

}

.works-details-img img {
  width: 100%;
  height: 311px;
  -o-object-fit: cover;
  object-fit: cover;
}

.works-details-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 1;
  color: #F2F2F7;
  width: 100%;
}

.founder-info-row {
  position: relative;
  margin: 112px 120px 0;
}

.mb-112 {
  margin-bottom: 112px;
}

.founder-info {
  background-color: #1C1C1E;
  opacity: 70%;
  position: absolute;
  top: 46%;
  left: 68%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 1;
  color: #F2F2F7;
  width: 100%;
}

.founder-info {
  width: 444px;
  padding: 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.founder-info p {
  width: 290px;
}

.founder-info img {
  padding: 40px 0 24px;
}

.italic {
  font-style: italic;
}

.flex-wrap {
  display: flex;
  flex-direction: column;
}

.flex-wrap span:first-child {
  padding-bottom: 8px;
}

.founder-info-row .row {
  --bs-gutter-x: 0;
}

.founder-info-img img {
  width: 100%;
}

.founder-info img.colon-top {
  position: absolute;
  top: 3%;
  left: 11%;
  padding: 0;
}

.founder-info img.colon-bottom {
  position: absolute;
  right: 36%;
  padding-top: 1%;
}

.awards {
  background-color: #FAFAFA;
  padding-bottom: 112px;
}

.works img.cafted-text-img {
  width: 50%;
}

.carousel-inner {
  cursor: pointer;
}

.awards-img img {
  padding-right: 24px;
}

.reviews-header {
  font-family: 'Dancing Script', cursive;
  font-size: 4.5rem;
  color: #333;
}

/* Card Styling */
#review-carousel .custom-card {
  border-radius: 12px;
  background-color: #FAFAFA; 
  padding: 32px;
}

.profile-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.review-body {
  display: -webkit-box;
  -webkit-line-clamp: 3; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accent-bar {
  width: 60px;
  height: 8px; 
} 
.dot.active {
  background: #333;
}

/* FB Button */
.btn-fb {
  background-color: #1a1a1a;
  border-radius: 4px;
  font-weight: 500;
}
#review-carousel .carousel-inner img.star-img{
  height: 16px  !important;
  width: 16px  !important;
}
.btn.btn-dark{
  border-radius: unset;
  padding: 16px 24px;
}
.btn.btn-dark img{
  padding-left: 8px;
}
@media (max-width: 992px) {
  .works-details-img img {
    height: 311px;
  }

  .founder-info {
    padding: 24px;
    top: 50%;
  }

  .founder-info-row {
    margin: 56px 16px 0;
  }

  .mb-112 {
    margin-bottom: 56px;
  }

  .founder-info img {
    padding: 24px 0;
  }

  .awards {
    padding-bottom: 56px;
  }
}

@media (max-width: 576px) {
  .home-page .carousel-inner img {
    width: 100% !important;
    height: 100vh !important;
    object-fit: cover;
  }

  .home-page .carousel-caption {
    width: 100%;
    right: 0;
  }

  .home-page .carousel-caption p {
    text-align: center;

  }

  .home-page .carousel-control-next,
  .home-page .carousel-control-prev {
    bottom: 14%;
    top: unset;
  }

  .works {
    padding-bottom: 56px;
  }

  .works-details-row {
    padding: 30px;
  }

  .works-details-img {
    margin-bottom: 15px;

  }

  .works-details-img img {
    height: 230px;
  }

  .works-details-row .title-1 {
    font-size: 1.475rem;
    letter-spacing: 0.4em;
    margin-bottom: 0
  }

  .works-details-row .title-2 {
    font-size: 1rem;
    padding-left: 20px;
    letter-spacing: 3em;
  }

  .founder-info {
    position: sticky;
    transform: none;
    width: 100%;
  }

  .founder-info img.colon-top {
    top: 4%;
    left: 4%;
  }

  .awards-img img {
    width: 100%;
    padding: 0 40px 56px;
  }

  .works img.cafted-text-img {
    width: 80%;
  }
}
</style>
